import { useState } from 'react';
import { useSession } from '../../context/SessionContext';
import { DashboardTab } from './DashboardTab';
import { AoVivoTab } from './AoVivoTab';
import { FuncionariosTab } from './FuncionariosTab';
import { PerfisTab } from './PerfisTab';
import { PontoLogTab } from './PontoLogTab';
import { AlimLogTab } from './AlimLogTab';
import { RecebimentosLogTab } from './RecebimentosLogTab';
import { DocumentosMgrTab } from './DocumentosMgrTab';
import { ConfigTab } from './ConfigTab';
import { RemindersTab } from './RemindersTab';
import { ComunicadorTab } from './ComunicadorTab';
import { ThemeToggle } from '../../components/ThemeToggle';
import { DocumentacaoTab } from './DocumentacaoTab';
import { AuditoriaTab } from './AuditoriaTab';

type MgrTab = 'dashboard' | 'aovivo' | 'funcionarios' | 'perfis' | 'ponto' | 'alim' | 'recv' | 'docs' | 'lembretes' | 'comunicador' | 'documentacao' | 'auditoria' | 'config';

export function ManagerShell() {
  const { logout } = useSession();
  const [tab, setTab] = useState<MgrTab>('dashboard');

  const tabs: { key: MgrTab; label: string }[] = [
    { key: 'dashboard', label: 'Dashboard' },
    { key: 'aovivo', label: 'Ao vivo' },
    { key: 'funcionarios', label: 'Funcionários' },
    { key: 'perfis', label: 'Perfis & Assinaturas' },
    { key: 'ponto', label: 'Ponto' },
    { key: 'alim', label: 'Alimentação' },
    { key: 'recv', label: 'Recebimentos' },
    { key: 'docs', label: 'Documentos' },
    { key: 'lembretes', label: 'Lembretes' },
    { key: 'comunicador', label: 'Comunicador' },
    { key: 'documentacao', label: 'Documentação' },
    { key: 'auditoria', label: 'Auditoria' },
    { key: 'config', label: 'Configurações' },
  ];

  return (
    <>
      <div className="brand">
        <div className="stamp-mark"><span>C</span></div>
        <div><div className="brand-name" style={{ fontSize: 17 }}>Painel do gestor</div><div className="brand-sub">Camarotes · Carnaval</div></div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}><ThemeToggle /><button className="btn btn-ghost btn-sm" onClick={logout}>Sair</button></div>
      </div>
      <div className="mgr-tabs">
        {tabs.map((t) => (
          <button key={t.key} className={`mgr-tab ${tab === t.key ? 'active' : ''}`} onClick={() => setTab(t.key)}>{t.label}</button>
        ))}
      </div>
      {tab === 'dashboard' && <DashboardTab />}
      {tab === 'aovivo' && <AoVivoTab />}
      {tab === 'funcionarios' && <FuncionariosTab />}
      {tab === 'perfis' && <PerfisTab />}
      {tab === 'ponto' && <PontoLogTab />}
      {tab === 'alim' && <AlimLogTab />}
      {tab === 'recv' && <RecebimentosLogTab />}
      {tab === 'docs' && <DocumentosMgrTab />}
      {tab === 'lembretes' && <RemindersTab />}
      {tab === 'comunicador' && <ComunicadorTab />}
      {tab === 'documentacao' && <DocumentacaoTab />}
      {tab === 'auditoria' && <AuditoriaTab />}
      {tab === 'config' && <ConfigTab />}
    </>
  );
}
